export default "__VITE_ASSET__CHGWWbxH__"